module.exports = __webpack_public_path__ + "static/media/1012829.fe0846c4.png";